/** Defaults for Client Catalogue import modal filters */

export function createEmptyImportFilters() {
  return {
    category: [],
    productName: [],
    finish: [],
    color: [],
    suitableFor: [],
    material: [],
    collection: [],
    packType: [],
  };
}
